import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { SelectPesquisavelComponent } from '../../../../../shared/components/select-pesquisavel/select-pesquisavel.component';
import { Editor, NgxEditorModule, Toolbar } from 'ngx-editor';

import { TagVenda } from '../../../../../shared/services/models/vendas/tag-venda.model';

/**
 * Secao Dados adicionais - observacoes e marcadores.
 *
 * `observacoes` vale nos DOIS processos e mora so aqui: no orcamento e o texto de condicoes da
 * proposta (nasce com a observacao padrao da configuracao do orcamento), no pedido o texto impresso
 * no pedido. Um controle so para a coluna.
 *
 * `observacoesInternas` nunca e impresso: e recado entre quem vende e quem separa/fatura.
 *
 * O titulo e o recolher da secao sao do shell; no PEDIDO a configuracao "Dados adicionais"
 * (Sim / Nao / Exibir recolhido) decide se ela aparece e se nasce recolhida.
 */
@Component({
    selector: 'app-vd-adicionais',
    standalone: true,
    imports: [
        ReactiveFormsModule,
        SelectPesquisavelComponent,
        NgxEditorModule,
    ],
    templateUrl: './vd-adicionais.component.html',
    styleUrl: './vd-adicionais.component.css',
})
export class VdAdicionaisComponent implements OnInit, OnDestroy {
    @Input({ required: true }) public form!: FormGroup;
    @Input() public ehOrcamento: boolean = true;
    @Input() public tags: TagVenda[] = [];
    @Input() public isSomenteLeitura: boolean = false;

    /** O select de tags recebe o FormControl direto, nao o nome - e o contrato do componente. */
    public get tagsControl(): FormControl {
        return this.form.get('idsTagVenda') as FormControl;
    }

    public editorObservacoes!: Editor;
    public editorInternas!: Editor;

    public readonly toolbar: Toolbar = [
        ['bold', 'italic'],
        ['underline', 'strike'],
        ['ordered_list', 'bullet_list'],
        ['align_left', 'align_center', 'align_right', 'align_justify'],
    ];

    public ngOnInit(): void {
        this.editorObservacoes = new Editor();
        this.editorInternas = new Editor();
    }

    public ngOnDestroy(): void {
        this.editorObservacoes?.destroy();
        this.editorInternas?.destroy();
    }
}
